// @flow
import React from 'react';

export const EmbedContext = React.createContext<any>();
